import { call, put } from 'redux-saga/effects';
import { requestGetAccount, requestGetAccounts, requestGetAccountBillingEntities, requestGetAccountProjects, requestGetAccountGroups, requestCreateAccount, requestUpdateAccount, requestActivateAccount, requestDeactivateAccount, requestGetAccountMembers, requestAddAccountMembers, requestRemoveAccountMembers, requestDeleteAccount, requestRestoreAccount } from '../requests/account';
import { showAlert } from '../../slices/alerts';
import { safeErrorMessage } from '../../../utils/errorUtils';
import { setAccountId, usersReceived } from '../../slices/users';
import { setRetainerStatus } from '../../slices/retainerStatus';

export function* handleGetAccounts(action) {
    try {
        const { start, limit, client, pinned, callback } = action.payload;
        const response = yield call(requestGetAccounts, start, limit, client, pinned);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        const { callback } = action.payload;
        if (callback) {
            callback(null);
        }
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleGetClientAccountsTime(action) {
    try {
        const { clientId, callback } = action.payload;
        const response = yield call(requestGetAccounts, 0, 1000, clientId, false, true);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleGetAccountBillingEntities(action) {
    try {
        const { callback } = action.payload;
        const response = yield call(requestGetAccountBillingEntities);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (action.payload?.callback) {
            action.payload.callback(null);
        }
    }
}

export function* handleGetAccount(action) {
    try {
        const { accountId, callback } = action.payload;
        const response = yield call(requestGetAccount, accountId);
        if (response.data?.retainerStatus) {
            yield put(setRetainerStatus({ key: `account:${response.data._id}`, status: response.data.retainerStatus }));
        }
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
    }
}

export function* handleGetAccountProjects(action) {
    try {
        const { accountId, state, callback } = action.payload;
        const response = yield call(requestGetAccountProjects, accountId, state);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
        if (action.payload.callback) action.payload.callback(null);
    }
}

export function* handleGetAccountGroups(action) {
    try {
        const { accountId, callback } = action.payload;
        const response = yield call(requestGetAccountGroups, accountId);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        const { callback } = action.payload;
        if (callback) {
            callback(null);
        }
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
    }
}

export function* handleCreateAccount(action) {
    try {
        const { clientId, accountData, callback } = action.payload;
        const response = yield call(requestCreateAccount, clientId, accountData);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
    }
}

export function* handleUpdateAccount(action) {
    try {
        const { accountId, accountData, callback } = action.payload;
        const response = yield call(requestUpdateAccount, accountId, accountData);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        const { callback } = action.payload;
        if (callback) {
            callback(null);
        }
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
    }
}

export function* handleActivateAccount(action) {
    try {
        const { accountId, callback } = action.payload;
        const response = yield call(requestActivateAccount, accountId);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
    }
}

export function* handleDeactivateAccount(action) {
    try {
        const { accountId, callback } = action.payload;
        const response = yield call(requestDeactivateAccount, accountId);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
    }
}

export function* handleGetAccountMembers(action) {
    try {
        const { accountId, callback } = action.payload;
        const response = yield call(requestGetAccountMembers, accountId);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
    }
}

export function* handleAddAccountMembers(action) {
    try {
        const { accountId, accountMembers, callback } = action.payload;
        const response = yield call(requestAddAccountMembers, accountId, accountMembers);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
    }
}

export function* handleRemoveAccountMembers(action) {
    try {
        const { accountId, accountMembers, callback } = action.payload;
        const response = yield call(requestRemoveAccountMembers, accountId, accountMembers);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
    }
}

export function* handleDeleteAccount(action) {
    try {
        const { accountId, callback } = action.payload;
        const response = yield call(requestDeleteAccount, accountId);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
    }
}

export function* handleRestoreAccount(action) {
    try {
        const { accountId, callback } = action.payload;
        const response = yield call(requestRestoreAccount, accountId);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
    }
}

export function* handleFetchAccountUsers(action) {
    try {
        const { accountId, callback } = action.payload;
        const response = yield call(requestGetAccountMembers, accountId);
        yield put(setAccountId(accountId));
        yield put(usersReceived(response.data));
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
    }
}